import type { RTCOClickHotelPayload, RTCOClickHotelResponse } from '@/app/api/search/rtcoclickhotel/rtclClickHotel.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { API_NAME } from '@/app/components/search/common/apiTypes.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import type { Localization } from '../common/Localization';
import { isNil } from '../Utilities';
import clientAPICall from '../common/clientAPICall.ts';

type RTCOClientClickHotel = {
  searchParams: SearchParams;
  searchInfoData: SearchInfoData;
  localization: Localization;
  hotelId: number;
  commonData: CommonData;
};
const rtcoClientClickHotel = async ({
  searchParams,
  searchInfoData,
  localization,
  hotelId,
  commonData,
}: RTCOClientClickHotel) => {
  const payload: RTCOClickHotelPayload = {
    searchMode: searchInfoData.searchMode,
    localization,
    dateFrom: searchParams[URLParameters.DATE_FROM],
    dateTo: searchParams[URLParameters.DATE_TO],
    adults: searchParams[URLParameters.ADULTS],
    childrenAges: searchParams[URLParameters.AGES],
    hotelId: (isNil(hotelId) ? '' : hotelId).toString(),
  };
  await clientAPICall<RTCOClickHotelPayload, RTCOClickHotelResponse>({
    apiName: API_NAME.RTCO_CLICK_HOTEL,
    payload,
    traceParent: searchInfoData.searchTraceParent,
    commonData,
  });
};

export default rtcoClientClickHotel;
